import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import numberArrayGenerator from 'number-array-generator';
import Helmet from 'react-helmet';
import MenuItem from 'material-ui/MenuItem';
import { Link } from 'react-router';
import AutoComplete from 'material-ui/AutoComplete';
import Paper from 'material-ui/Paper';
import AdBlockDetect from 'react-ad-block-detect';
import cookie from 'js-cookie';
import { reduxForm, Field, formValueSelector, change } from 'redux-form';
import { generateFacebookTargetingSpec } from '../../../helpers/facebookAdTargeting';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import DropDownMenu from 'material-ui/DropDownMenu';
import TextField from 'material-ui/TextField';
import { Accordion, AdStep2Preview, ButtonBar, FormSection, PageHeader, MultiAccordionSection, SecondaryButton } from 'components';
import { connect } from 'react-redux';
import moment from 'moment';
import ReactTooltip from 'react-tooltip';
import RaisedButton from 'material-ui/RaisedButton';
import { addNewCustomConsent, setCustomConsentText, setCustomConsentRequired, removeCustomConsent } from 'redux/modules/adBuilder';
import Checkbox from 'material-ui/Checkbox';
import * as styles from './style.scss';
var PrivacyPolicy = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    organization: state.organization.current,
    adAccount: state.ads.adAccount && state.ads.adAccount[orgId] ? state.ads.adAccount[orgId] : null,
    formValues: state.form["adForm_".concat(orgId)] ? state.form["adForm_".concat(orgId)].values : {},
    theme: state.theme
  };
}, {
  addNewCustomConsent: addNewCustomConsent,
  setCustomConsentText: setCustomConsentText,
  setCustomConsentRequired: setCustomConsentRequired,
  removeCustomConsent: removeCustomConsent
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(PrivacyPolicy, _Component);

  var _super = _createSuper(PrivacyPolicy);

  function PrivacyPolicy() {
    _classCallCheck(this, PrivacyPolicy);

    return _super.apply(this, arguments);
  }

  _createClass(PrivacyPolicy, [{
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/React.createElement("section", {
        style: {
          margin: '1rem'
        }
      }, this.props.validationErrors && this.props.validationErrors.length > 0 && /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: 50
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          color: 'red'
        }
      }, "There are errors in this section.")), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("ul", null, this.props.validationErrors.map(function (e) {
        return /*#__PURE__*/React.createElement("li", {
          style: {
            color: 'red'
          }
        }, e);
      })))), /*#__PURE__*/React.createElement("small", null, "Because you will be collecting customer information, you need to include a link to your company's privacy policy. Your link will appear with Facebook's default privacy disclaimer."), /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          marginTop: 20
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-2 ".concat(styles.textFieldLabel)
      }, "Link Text"), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-9"
      }, this.props.builder && /*#__PURE__*/React.createElement(TextField, {
        hintText: "",
        value: this.props.builder.privacyPolicyLinkText,
        fullWidth: true,
        onChange: function onChange(_ref) {
          var target = _ref.target;
          return _this.props.changeField('privacyPolicyLinkText', target.value);
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-1"
      }, 70 - (this.props.builder && this.props.builder.privacyPolicyLinkText ? this.props.builder.privacyPolicyLinkText.length : 0))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-2 ".concat(styles.textFieldLabel)
      }, "Link URL"), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-8"
      }, this.props.builder && /*#__PURE__*/React.createElement(TextField, {
        hintText: "Required",
        value: this.props.builder.privacyPolicyURL,
        fullWidth: true,
        onChange: function onChange(_ref2) {
          var target = _ref2.target;
          return _this.props.changeField('privacyPolicyURL', target.value);
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-2"
      }, /*#__PURE__*/React.createElement(RaisedButton, {
        fullWith: true,
        label: "Reset",
        onClick: function onClick() {
          var url = "https://".concat(window.location.hostname, "/privacy-policy/").concat(_this.props.organization.id);

          _this.props.changeField('privacyPolicyURL', url);
        }
      }))), /*#__PURE__*/React.createElement("p", {
        style: {
          marginTop: 12,
          marginBottom: 12,
          marginLeft: 0,
          marginRight: 0,
          fontWeight: '500'
        }
      }, "Custom Disclaimer"), /*#__PURE__*/React.createElement("small", null, "You can add additional notices like marketing opt-ins and legal disclaimers to the default Facebook privacy disclaimer."), this.props.builder && /*#__PURE__*/React.createElement(Checkbox, {
        style: {
          marginTop: 10,
          marginBottom: 20
        },
        checked: this.props.builder.customDisclaimerEnabled,
        label: "Add custom disclaimer",
        onCheck: function onCheck() {
          _this.props.changeField('customDisclaimerEnabled', !_this.props.builder.customDisclaimerEnabled);
        }
      }), this.props.builder && this.props.builder.customDisclaimerEnabled && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-2 ".concat(styles.textFieldLabel)
      }, "Title"), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-9"
      }, this.props.builder && /*#__PURE__*/React.createElement(TextField, {
        hintText: "",
        value: this.props.builder.customDisclaimerTitle,
        fullWidth: true,
        onChange: function onChange(_ref3) {
          var target = _ref3.target;
          return _this.props.changeField('customDisclaimerTitle', target.value);
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-1"
      }, 60 - (this.props.builder && this.props.builder.customDisclaimerTitle ? this.props.builder.customDisclaimerTitle.length : 0))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-2 ".concat(styles.textFieldLabel)
      }, "Text"), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-10"
      }, this.props.builder && /*#__PURE__*/React.createElement(TextField, {
        hintText: "Add disclaimer (Required)",
        value: this.props.builder.customDisclaimerText,
        fullWidth: true,
        multiLine: true,
        rows: 2,
        rowsMax: 4,
        onChange: function onChange(_ref4) {
          var target = _ref4.target;
          return _this.props.changeField('customDisclaimerText', target.value);
        }
      }))), /*#__PURE__*/React.createElement("p", {
        style: {
          marginTop: 12,
          marginBottom: 12,
          marginLeft: 0,
          marginRight: 0,
          fontWeight: '500'
        }
      }, "Consent Checkbox (optional)"), /*#__PURE__*/React.createElement("small", null, "You can ask people to explicitly agree to your disclaimer or any additional notices."), this.props.builder && /*#__PURE__*/React.createElement("span", null, this.props.builder.customDisclaimerConsents.map(function (consent, idx) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            padding: '1rem',
            margin: '1rem',
            border: '1px solid rgb(225, 225, 225)'
          }
        }, /*#__PURE__*/React.createElement("p", {
          style: {
            marginTop: 12,
            marginBottom: 12,
            marginLeft: 0,
            marginRight: 0,
            fontWeight: '500'
          }
        }, "Consent ", idx + 1), /*#__PURE__*/React.createElement(TextField, {
          hintText: "Required",
          fullWidth: true,
          value: consent.text,
          onChange: function onChange(_ref5) {
            var target = _ref5.target;

            _this.props.changeField("customDisclaimerConsents[".concat(idx, "].text"), target.value);
          }
        }), /*#__PURE__*/React.createElement("div", {
          className: "row",
          style: {
            marginTop: 20
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "col-xs-4"
        }, "Is user consent required?"), /*#__PURE__*/React.createElement("div", {
          className: "col-xs-8"
        }, /*#__PURE__*/React.createElement(RadioButtonGroup, {
          valueSelected: consent.isRequired ? 'yes' : 'no',
          onChange: function onChange(e, value) {
            _this.props.changeField("customDisclaimerConsents[".concat(idx, "].isRequired"), value === 'yes');
          }
        }, /*#__PURE__*/React.createElement(RadioButton, {
          value: "yes",
          label: "Yes"
        }), /*#__PURE__*/React.createElement(RadioButton, {
          value: "no",
          label: "No"
        })))), /*#__PURE__*/React.createElement("p", {
          style: {
            textAlign: 'right',
            color: '#5b5b9d',
            cursor: 'pointer'
          },
          onClick: function onClick() {
            _this.props.changeField("customDisclaimerConsents[".concat(idx, "]"), undefined);
          }
        }, "Remove consent"));
      })), /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          marginTop: 20
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12",
        style: {
          height: 50,
          border: '1px dashed #dadcde',
          padding: '1rem',
          color: 'rgb(130, 130, 130)',
          cursor: 'pointer'
        },
        onClick: function onClick(e) {
          _this.props.changeField("customDisclaimerConsents[".concat(_this.props.builder.customDisclaimerConsents.length, "]"), {
            text: '',
            isRequired: false
          });
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-plus",
        "aria-hidden": "true"
      }), " Add new consent"))));
    }
  }]);

  return PrivacyPolicy;
}(Component)) || _class);
export default PrivacyPolicy;